import instanceRequest, {Request} from "../../main/services/Request";
import { PAGINATION_HEADERS } from "../../main/store/constants";

class EventService {
    private axiosService: Request;

    public constructor(axiosService: Request) {
        this.axiosService = axiosService;
    }

    public async getEvents(
        page = 1,
        itemsPerPage: number|string = 20,
        sortKey = "date",
        sortDir = "desc",
        filters: any = {},
        equipments: string[] = [],
        format = "json",
    ) {
        const body = { equipments };
        const types = filters.types.map((type: any) => `types[]=${type}`);
        delete filters['types'];
        const filtersQuery = this.buildFiltersQuery(filters);
        const itemsPerPageQuery = itemsPerPage === 'all' ? `allItems=1` : `itemsPerPage=${itemsPerPage}`;
        
        const query = [];
        query.push(`currentPage=${page}`);
        query.push(itemsPerPageQuery);
        query.push(`sortKey=${sortKey}`);
        query.push(`sortDir=${sortDir}`);
        query.push(`format=${format}`);
        if(filtersQuery.length) {
            query.push(filtersQuery);
        }
        if(types.length) {
            query.push(types.join('&'));
        }
        
        const url = `/api/event?${query.join('&')}`;
  
        if (format === "json") {
            const response = await this.axiosService.post(url, body, false);
            return {
                pagination: this.getPaginationInfo(response.headers),
                data: response.data,
            };
        } else {
            return await this.axiosService.getBlobWithPost(url, body);
        }
    }

    getPaginationInfo(headers: any): any {
        const pagination: any = [];

        Object.entries(headers).map((header: any) => {
            if (PAGINATION_HEADERS.includes(header[0])) {
                pagination[header[0]] = header[1];
            }
            return pagination;
        });

        return pagination;
    }

    buildFiltersQuery(filters: any) {
        let query: any = [];
        Object.keys(filters).forEach((key) => {
            const value = (filters as any)[key];
            if(value !== undefined) {
                query.push(`${key}=${value}`);
            }
        });
        return query.join('&');
    }

    public getEventTypes() {
        const url = `/api/event-type`;
        return this.axiosService.get(url, false, false).then((response) => {
            return {
                data: response.data,
            };
        });
    }
}

export default new EventService(instanceRequest);
